(() => {
  if (window.vmNavigationLoaded) return;
  window.vmNavigationLoaded = true;
  const desktop = window.matchMedia('(min-width:1280px)');
  const finePointer = window.matchMedia('(hover:hover) and (pointer:fine)');
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-vm-language]');
    if (!link || !window.location.search) return;
    const target = new URL(link.href, window.location.href);
    target.search = window.location.search;
    link.href = target.href;
  }, true);
  function setup(root = document) {
    root.querySelectorAll('[data-vm-nav]').forEach(details => {
      if (details.dataset.vmReady) return;
      details.dataset.vmReady = 'true';
      let leaveTimer;
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        const list = details.closest('ul');
        list?.querySelectorAll('[data-vm-nav]').forEach(other => {
          if (other !== details) other.open = false;
        });
      });
      details.addEventListener('mouseenter', () => {
        clearTimeout(leaveTimer);
        if (desktop.matches && finePointer.matches && details.dataset.vmNav === 'desktop') details.open = true;
      });
      details.addEventListener('mouseleave', () => {
        if (desktop.matches && details.dataset.vmNav === 'desktop' && !details.contains(document.activeElement)) {
          leaveTimer = setTimeout(() => { details.open = false; }, 180);
        }
      });
      details.addEventListener('focusout', () => {
        setTimeout(() => {
          if (details.dataset.vmNav === 'desktop' && !details.contains(document.activeElement) && !details.matches(':hover')) details.open = false;
        }, 0);
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          details.open = false;
          details.querySelector('summary').focus();
        }
      });
    });
  }
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('[data-vm-nav="desktop"][open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  desktop.addEventListener('change', () => {
    document.querySelectorAll('[data-vm-nav="desktop"][open]').forEach(details => { details.open = false; });
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  setup();
})();
